import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { QuotService } from '../../services/quot.service';
import { Subscription } from 'rxjs';
import { AddressService } from '../../services/address.service';
import { CatalogsSettingsService } from '../../services/catalogs-settings.service';
import { toast } from 'angular2-materialize';
import { Utils } from '../../util';

@Component({
  selector: 'app-display-quot',
  templateUrl: './display-quot.component.html',
  styleUrls: ['./display-quot.component.css']
})
export class DisplayQuotComponent implements OnInit, OnDestroy {
  loading: boolean[] = [false, false];
  get loaded(): boolean { return !this.loading.includes(false); }

  quotId;
  quot: any = {};
  quotObject: any = {};
  prVnta: any = {};

  dataPhp: string;

  quotForm: FormGroup;

  sections: any[];
  generalActivities: any[];
  quantities: any[];
  finalTableRows: any[];
  finalTableHeaders: string[];

  currentSectionTab: number;
  currentSectionShowing: boolean;

  sub: Subscription;

  constructor(
    private service: QuotService,
    private addressService: AddressService,
    private settingsService: CatalogsSettingsService,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute
  ) {
    this.quotId = this.activatedRoute.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    this.createForm();

    this.sub = this.service.getQuot(this.quotId).subscribe(([quot]) => {
      this.quot = {quantityIndex: '0', ...quot};
      this.prVnta.id = quot.prVntaObj.id;
      this.prVnta.name = quot.prVntaObj.name;
      this.quotForm.patchValue(quot);
      this.quotForm.get('customerName').patchValue(quot.customerObj.name);
      this.quotForm.get('employeeSignName').patchValue(`${quot.employeeSignObj.name} ${quot.employeeSignObj.lastName}`);
      this.quotForm.get('createdByName').patchValue(`${quot.createdByObj.name} ${quot.createdByObj.lastName}`);
      this.quantities = quot.quantities;
      this.sections = quot.sections || [];
      this.generalActivities = quot.generalActivities || [];
      this.finalTableHeaders = quot.finalTableHeaders || [];
      this.finalTableRows = quot.finalTableRows ? quot.finalTableRows.map(row => row.row) : [];

      this.quotObject = {
        customerName: quot.customerObj.name,
        customerEmail: quot.customerObj.email,
        companyCities: `${quot.companyObj.municipality}, ${quot.companyObj.city}`,
        companyImgUrl: quot.companyObj.imageURL,
        companyName: quot.companyObj.name,
        companyAddress: quot.companyObj.street + ' ' + quot.companyObj.numExt + quot.companyObj.numInt + '&emsp;' + quot.companyObj.colony + '&emsp;' + quot.companyObj.municipality + '&emsp;' + quot.companyObj.city + '&emsp;C.P. ' + quot.companyObj.postCode,
        companyPhone: quot.companyObj.phoneOne,
        companyEmail: quot.companyObj.email,
        companyWebPage: quot.companyObj.webPage || '',
        folio: quot.folio,
        date: this.formatedDate(quot.date),
        shortDescription: quot.shortDescription,
        longDescription: quot.longDescription,
        table: this.formatedTable(quot),
        deliveryCommitment: quot.deliveryCommitment,
        sections: quot.sections,
        generalActivities: quot.generalActivities,
        employeeName: `${quot.employeeSignObj.name} ${quot.employeeSignObj.lastName}`,
        employeeCellPhone: quot.employeeSignObj.cellPhone || '',
        employeeExtPhone: quot.employeeSignObj.extPhone || '',
        employeeEmail: quot.employeeSignObj.email,
        keyPersonName: quot.keyPersonName,
        keyPersonJob: quot.keyPersonJob,
        payConditions: quot.payConditions || '',
        notes: quot.notes
      }

      let customerSub = this.addressService.getCustomerAddresses(quot.customerObj.id, {onEmpty: ()=>{this.loading[0] = true;} }).subscribe(([address = {}]) => {
        customerSub.unsubscribe();
        let {
          street = '',
          internalNumber = '',
          externalNumber = '',
          neighborhood = '',
          zipCode = '',
          municipality = '',
          city = ''
        } = address;

        this.dataPhp = JSON.stringify({
          customerAddress: {street, internalNumber, externalNumber, neighborhood, zipCode, municipality, city},
          ...this.quotObject
        });
        this.loading[0] = true;
      });

      this.loading[1] = true;
    });

    let setSub = this.settingsService.getPayrollSettings('1').subscribe(settings => {
      setSub.unsubscribe();
      this.quotObject.isoDescription = settings.isoDescriptions.COT;
    })
  }
  ngOnDestroy(){
    this.sub.unsubscribe();
  }

  createForm() {
    this.quotForm = this.fb.group({
      folio: ['', Validators.required],
      date: ['', Validators.required],
      status: ['', Validators.required],
      shortDescription: '',
      deliveryCommitment: '',
      longDescription: '',
      quantityIndex: '0',
      iva: '',
      utility: '',
      fixed: '',
      commission: '',
      merma: '',
      payConditions: '',
      notes: '',
      notesPrivate: '',

      customerName: ['', Validators.required],
      keyPersonName: ['', Validators.required],
      keyPersonJob: ['', Validators.required],
      employeeSignName: ['', Validators.required],
      createdByName: ['', Validators.required],
    });
  }

  tooltipIsShowing = [];
  generalTooltipIsShowing = [];
  tooltipActivity(activity){
    switch(activity.quantityPricesFunction){
      case "papel": return `${activity.unique.prCmpaDescription}, $${activity.prices[0]}`;
      default: return "";
    }
  }

  changeSectionTab(index) {
    if(this.currentSectionTab == index) this.currentSectionShowing = !this.currentSectionShowing;
    else{
      this.currentSectionTab = index;
      this.currentSectionShowing = true;
    }
  }

  money = Utils.money;

  formatedDate(dateStr: string){
    let as_date = dateStr.split('-');
    const date = new Date(+as_date[0], +as_date[1]-1, +as_date[2]);
    const days = [ 'Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado' ];
    const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    const s_day = days[date.getDay()];
    const i_day = date.getDate() < 9 ? `0${date.getDate()}` : date.getDate();
    const s_month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${s_day}, ${i_day} de ${s_month} del ${year}`;
  }
  formatedTable(quot: any){
    var columns: any[] = quot.finalTableHeaders.map( (header, hIndex) => {
      return { name: header, quantityPrices: quot.quantities.map( (quantity, qIndex) => quot.finalTableRows[qIndex].row[hIndex] ) }
    });
    const columnPrices = name => columns[this.finalTableHeaders.indexOf(name)].quantityPrices;
    return {
      'Piezas': quot.quantities,
      'Precio Unitario':  columnPrices('Precio x Pza'),
      'Subtotal': columnPrices('Precio'),
      'I.V.A': columnPrices(`Iva ${quot.iva}%`),
      'Total': columnPrices('Total')
    }
  }

  onEdit(){
    this.service.windowReplace('edit', `${this.quotId}`);
  }
  onApprove(){
    if(this.quot.approved) return toast('Ya fue aprobada y convertida a orden de producción.', 3000);
    let {
      companyObj, createdByObj, customerObj, employeeSignObj, prVntaObj,
      createdAt, finalTableHeaders, finalTableRows, keyPersonJob, keyPersonName,
      createdByRef: {id: createdById}, customerRef: {id: customerId}, employeeSignRef: {id: employeeSignId}, prVntaRef: {id: prVntaId},
      quantities, pricePerUnits, ...quot
    } = this.quot;
    let quantity = quantities[+quot.quantityIndex];
    let pricePerUnit = pricePerUnits[+quot.quantityIndex];
    //let [{unique:{mermas:{[+quot.quantityIndex]: merma=0}=[]}={}}] = quot.sections.map(({activities}) => activities.find(({unique=<any>{}}) => unique.mermas)).filter(a => a);
    quot.sections.map(s => s.activities.map(a => { if(a && a.unique && a.unique.mermas){ a.unique.merma = a.unique.mermas[+quot.quantityIndex]; delete a.unique.mermas; } }))
    localStorage.quot = JSON.stringify({createdById, customerId, employeeSignId, prVntaId, quantity, pricePerUnit, ...quot});
    this.service.windowReplace('odp', `${customerObj.id}`);
  }

}
